import { NavigationStepType, StepStatus } from "../types";

export const PurchaseTitleModalNavigation = ({ steps }: { steps: NavigationStepType[] }) => {
  return (
    <ol className="list-none border divide-y rounded-md border-border-action divide-border-divide md:flex md:divide-y-0">
      {steps.map((step, stepIdx) => (
        <li key={step.name} className="relative md:flex md:flex-1">
          {step.status === StepStatus.Complete && <StepComplete step={step} />}
          {step.status === StepStatus.Current && <StepCurrent step={step} />}
          {step.status === StepStatus.Upcoming && <StepUpcoming step={step} />}
          {stepIdx !== steps.length - 1 ? <ArrowSeparator /> : null}
        </li>
      ))}
    </ol>
  );
};

const StepComplete = ({ step }: { step: NavigationStepType }) => {
  return (
    <div onClick={step.onClick} className="flex items-center w-full cursor-pointer group">
      <span className="flex items-center px-3 py-2 text-sm font-medium">
        <span className="flex items-center justify-center w-10 h-10 rounded-full shrink-0 bg-positive-500 group-hover:bg-positive-600">
          <div className="w-6 h-6 text-white">
            <TickIcon />
          </div>
        </span>
        <span className="ml-4 text-sm font-medium text-text-base-primary-disabled">{step.name}</span>
      </span>
    </div>
  );
};
const StepCurrent = ({ step }: { step: NavigationStepType }) => {
  return (
    <div
      onClick={() => step.onClick}
      className="flex items-center px-3 py-2 text-sm font-medium cursor-pointer"
      aria-current="step"
    >
      <span className="flex items-center justify-center w-10 h-10 border-2 rounded-full shrink-0 border-platform-700 border-border-action-hover">
        <span className="text-border-action-hover text-platform-700">{step.id}</span>
      </span>
      <span className="ml-4 text-sm font-medium text-border-action-hover text-platform-700">{step.name}</span>
    </div>
  );
};
const StepUpcoming = ({ step }: { step: NavigationStepType }) => {
  return (
    <div onClick={() => step.onClick} className="flex items-center group">
      <span className="flex items-center px-3 py-2 text-sm font-medium cursor-pointer">
        <span className="flex items-center justify-center w-10 h-10 border-2 rounded-full shrink-0 border-text-base-tertiary group-hover:border-text-base-primary-disabled">
          <span className="text-text-base-tertiary group-hover:text-text-base-primary-disabled">{step.id}</span>
        </span>
        <span className="ml-4 text-sm font-medium text-text-base-tertiary group-hover:text-text-base-primary-disabled">
          {step.name}
        </span>
      </span>
    </div>
  );
};

const ArrowSeparator = () => {
  return (
    <div className="absolute top-0 right-0 hidden w-5 h-full md:block" aria-hidden="true">
      <svg className="w-full h-full text-border-divider" viewBox="0 0 22 80" fill="none" preserveAspectRatio="none">
        <path d="M0 -2L20 40L0 82" vectorEffect="non-scaling-stroke" stroke="currentcolor" strokeLinejoin="round" />
      </svg>
    </div>
  );
};

const TickIcon = () => {
  return (
    <svg className="w-6 h-6 text-white" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path
        fillRule="evenodd"
        d="M19.916 4.626a.75.75 0 01.208 1.04l-9 13.5a.75.75 0 01-1.154.114l-6-6a.75.75 0 011.06-1.06l5.353 5.353 8.493-12.739a.75.75 0 011.04-.208z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
